import React from "react"

import { H3, LinkWithArrow } from "components/text"
import { Container } from "components/grid"
import { MainContainer, FlexWrapper } from "components/main-container"
import { Box } from "components/box"

import { baseRoutes } from "routes"
import contentfulIndex from "contentful/drugFacts.json"
import { DrugFactsIndex } from "pages/drug-facts/drug-facts-types"

const DrugFactsDirectory = () => {
  const { drugFacts } = contentfulIndex as DrugFactsIndex
  const drugs = Object.values(drugFacts)

  return (
    <MainContainer
      pageWrapperComponent={FlexWrapper}
      mainContent={
        <Box py={[7, null, 9]} bg="iceBlue">
          <Container textAlign="center" pb={[5, null, 9]}>
            <H3 mb={6}>List of drug facts:</H3>
            {Object.values(drugs).map(({ path, title }) => (
              <Box key={path} mt={4}>
                <LinkWithArrow to={`${baseRoutes.drugFacts()}/${path}`}>{title}</LinkWithArrow>
              </Box>
            ))}
          </Container>
        </Box>
      }
    />
  )
}

export default DrugFactsDirectory
